const ProductListingLevels =
    process.env['GATSBY_ENABLE_BADGELESS_CARDS'] !== '1'
        ? ['Premium MasterSpec', 'Premium', 'Premium Proprietary']
        : ['Premium Proprietary', 'Product Listing']

export const listingTypes: string[] =
    process.env['GATSBY_ENABLE_BADGELESS_CARDS'] !== '1'
        ? ['Premium MasterSpec', 'Premium', 'Premium Proprietary']
        : ['Premium Proprietary', 'Product Listing']

export default ProductListingLevels
